if (!customElements.get("join-widget")) {
  customElements.define(
    "join-widget",
    class JoinWidget extends HTMLElement {
      constructor() {
        super();
        this.teamName = "manucurist";
        this.alias = this.dataset.alias;
        this.divId = "join-widget-" + this.alias;
        this.widgetLoaded = false;

        theme.initWhenVisible({
          element: this,
          callback: this.loadWidget.bind(this),
          threshold: 100,
        });
      }

      loadWidget() {
        if (this.widgetLoaded) return;
        const script = document.createElement("script");
        script.src = `https://${this.teamName}.my.join-stories.com/widgets/${this.alias}/index.js`;
        script.setAttribute("data-join-widget-id", this.divId);
        script.setAttribute("data-join-widget-alias", this.alias);
        script.setAttribute("type", "text/javascript");
        script.onerror = () => {
          this.classList.add("hidden");
        };
        this.appendChild(script);
        this.setAttribute("id", this.divId);
        this.widgetLoaded = true;
      }
    },
  );
}